import React from 'react';
import InstallmentTableSC, { PaginationWrapSC } from './installment-table.styled';
import { BodyText, SmallText } from '../../typography';
import InstallmentItem from './installment-item';
import { ReactComponent as LeftArrow } from '../../../assets/img/svg/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../../assets/img/svg/right-arrow.svg';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../../utils/screen-size';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import PropTypes from 'prop-types';

const InstallmentTable = ({ tableData, dueInstallmentCount, hasPagination }) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  const formatStatusOfInstallment = (installment) => {
    if (installment[0] <= dueInstallmentCount) {
      if (Number(installment[12]) > 0) {
        if (Number(installment[7]) > 0) {
          return 'partially';
        } else {
          return 'not-paid';
        }
      } else {
        return 'paid';
      }
    } else {
      return 'pending';
    }
  };

  return (
    <>
      <InstallmentTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="borrower_dash_installment_table_head_1"
                    defaultMessage={dlt['borrower_dash_installment_table_head_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="borrower_dash_installment_table_head_2"
                    defaultMessage={dlt['borrower_dash_installment_table_head_2']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="borrower_dash_installment_table_head_3"
                    defaultMessage={dlt['borrower_dash_installment_table_head_3']}
                  />
                </SmallText>
              </th>
            </tr>
          </thead>
        )}

        <tbody>
          {tableData.map((item) => {
            return (
              <InstallmentItem
                key={item[0]}
                amount={item[2]}
                date={item[1]}
                status={formatStatusOfInstallment(item)}
                isTablet={isTablet}
                hasPagination={hasPagination}
              />
            );
          })}
        </tbody>
      </InstallmentTableSC>

      {hasPagination ? (
        <PaginationWrapSC>
          <BodyText className="bolder orange">
            1-12 <FormattedMessage id="global_from" defaultMessage={dlt['global_from']} /> 72
          </BodyText>
          <div className="arrow-wrap">
            <button disabled>
              <LeftArrow />
            </button>
            <button>
              <RightArrow />
            </button>
          </div>
        </PaginationWrapSC>
      ) : null}
    </>
  );
};

InstallmentTable.propTypes = {
  hasPagination: PropTypes.bool,
};

InstallmentTable.defaultProps = {
  hasPagination: false,
};

export default InstallmentTable;
